import { ServiceEntryCategory } from '@fleet-pro/mobile-webview-api';

export const getCategoryText = (category: number) => {
    switch (category) {
        case ServiceEntryCategory.Unscheduled:
            return 'Unscheduled';
        case ServiceEntryCategory.Scheduled:
            return 'Scheduled';
        case ServiceEntryCategory.Repairs:
            return 'Repairs';
        default:
            return 'Unknown';
    }
};
